import { createContext } from 'react';
export const SearchParamsContext = /*#__PURE__*/createContext(null);
SearchParamsContext.displayName = 'SearchParamsContext';
export const PathnameContext = /*#__PURE__*/createContext(null);
PathnameContext.displayName = 'PathnameContext';
export const HistoryContext = /*#__PURE__*/createContext(null);
HistoryContext.displayName = 'HistoryContext';
export const HistoryBasePathContext = /*#__PURE__*/createContext(null);
HistoryBasePathContext.displayName = 'HistoryBasePathContext';